import React from 'react';

import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss, withRouter } from 'src/helpers';

import model from '../modifyModel';
import { MCButton, MCError, TextField } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import AlertManager from 'src/components/alert/AlertManager';
import { FormRow } from 'src/components/Form';

class AddQuick extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  add = (e) => {
    e.preventDefault();
    model.sendInvite(this.props.router.params.id, (err, data, success) => {
      if (success) {
        AlertManager.popup(AlertManager.TYPES.INFO, {
          close: false,
          width: 450,
          title: lang.t(LANG_CONST.notice.sent_invitation, {
            type: lang.t(LANG_CONST.patient).toLowerCase()
          }),
          actionButton: {
            label: LANG_CONST.buttons.ok,
            action: (actions) => {
              actions.hide();
            }
          }
        });
        this.back();
      }
    });
  };
  render() {
    const apiStateId = 'invite';
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;
    const handleChange = model.handleChange;

    return (
      <>
        <div className={'mc-container-content__body-content border'}>
          <div className={'mc-flex-20-col'}>
            {createState.error && (
              <div className={'mc-flex'}>
                <p className='mc-error'>{createState.errorMessage}</p>
              </div>
            )}
            <FormRow>
              <TextField
                disabled={!!this.props.router.params?.id}
                label={LANG_CONST.fullname}
                placeholder={lang.t(LANG_CONST.text.enter, {
                  attr: lang.t(LANG_CONST.fullname).toLowerCase()
                })}
                value={model.input('fullname')}
                name={'fullname'}
                onChange={(n, v) => {
                  model.resetApiState(apiStateId);
                  handleChange(n, v);
                }}
                template={6}
                onBlur={model.handleBlur}
                invalid={invalid}
              />
            </FormRow>
            <FormRow>
              <TextField
                label={LANG_CONST.email}
                disabled={!!this.props.router.params?.id}
                placeholder='uname@mail.com'
                type='email'
                name='email'
                value={model.input('email')}
                onChange={(n, v) => {
                  model.resetApiState(apiStateId);
                  handleChange(n, v);
                }}
                template={6}
                onBlur={model.handleBlur}
                invalid={invalid}
              />
              <TextField
                template={6}
                disabled={!!this.props.router.params?.id}
                defaultCountryName={model.state.tempCountryAddress}
                name={'phoneNumber'}
                type='phone'
                value={model.input('phoneNumber').toString()}
                onChange={(n, v) => {
                  model.resetApiState(apiStateId);
                  handleChange(n, v);
                }}
                onBlur={model.handleBlur}
                label={LANG_CONST.phone_number}
                invalid={invalid}
              />
            </FormRow>
            {invalid?.emailOrPhone && (
              <MCError mcTextProps={{ primary: true }} error={invalid?.emailOrPhone} />
            )}
          </div>
        </div>
        <div className={'mc-container-content__body-footer'}>
          <div className={'mc-flex'}>
            <div className={'mc-grow'}></div>
            <MCButton
              primary
              dark
              radius
              style={{ width: remCss(200) }}
              medium
              disabled={createState.loading}
              loading={createState.loading}
              onClick={this.add}
              label={LANG_CONST.buttons.send_invite}
            />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(AddQuick);
